import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import MyCommitmentsList from "../Components/MyCommitmentsList";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./MyCommitments.css";

function MyCommitments() {
  const [isLoading, setIsLoading] = useState(true);
  const [commitments, setCommitments] = useState([]);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/commitments/organization/${state.userId}`,
        data: {
          organization: state.organization,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setCommitments(response.data.commitments);
      setIsLoading(false);
    }
    fetch();
  }, []);

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="my-commitments-header">
            <h2>{t("Compromisos.MisCompromisos.Titulo")}</h2>
          </Col>
          <Col lg={1} className="right my-commitments-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/commitments/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Compromisos.MisCompromisos.NuevoCompromiso")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row className="align-items-center">
          {commitments.length === 0 ? (
            <Col className="empty-commitments center">
              <h5>{t("Compromisos.MisCompromisos.SinCompromisos")}</h5>
            </Col>
          ) : (
            <MyCommitmentsList commitments={commitments} />
          )}
        </Row>
      </Container>
    );
  }
}

export default MyCommitments;
